module.exports = __webpack_public_path__ + "img/bscscan.64a69772.png";